"use client";
import { LockBodyScroll } from "cy-ui/components/LockBodyScroll";
import { LoadingOverlay } from "cy-ui/components/loaders/LoadingOverlay";
import { LoginDetails, ResetRequestForm } from "./ResetRequestForm";
import { SubmitNewPasswordArgs, UpdateForm } from "./UpdateForm";
import { urls } from "../urls";
import { useState } from "react";
import {
  PasswordResetRequest,
  passwordResetRequestClient,
  PasswordUpdateRequest,
} from "cy-api/simple-payments/customer/passwordResetRequestClient";
import { notify } from "cy-fe";
import { passwordUpdateClient } from "cy-api/simple-payments/customer/passwordUpdateClient";
import { useRouter } from "next/navigation";

export function PageClient() {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [login, setLogin] = useState<LoginDetails>({
    userId: null,
    mobile: null,
  });

  const otpSent = !!(login.userId || login.mobile);

  const getResetLoginDetailsRequest = (
    args: LoginDetails,
  ): PasswordResetRequest => {
    if (args.mobile) {
      return { mobile: args.mobile };
    } else if (args.userId?.includes("@")) {
      return { email: args.userId };
    }
    return { external_id: args.userId || undefined };
  };

  const requestOtpHandler = async (args: LoginDetails) => {
    setLoading(true);
    const request = getResetLoginDetailsRequest(args);

    const [_resp, err] = await passwordResetRequestClient(request);

    setLoading(false);
    if (err) {
      notify("Error", "Error in request", { error: err });
    } else {
      setLogin(args);
    }
  };

  const submitNewPasswordHandler = async (args: SubmitNewPasswordArgs) => {
    setLoading(true);
    const request: PasswordUpdateRequest = {
      ...getResetLoginDetailsRequest(login),
      password: args.password,
      reset_password_token: args.resetToken,
    };

    const [_resp, err] = await passwordUpdateClient(request);

    setLoading(false);

    if (err) {
      return err.data?.status;
    }

    notify("Success", "Password updated successfully");
    // Refresh must be called BEFORE push to invalidate the Router Cache
    // and ensure fresh data is displayed on navigation
    router.refresh();
    router.push(urls.signIn.href);
  };

  return (
    <>
      {loading ? <Loading /> : null}
      {otpSent ? (
        <UpdateForm
          onResendPin={() => requestOtpHandler(login)}
          onSubmit={submitNewPasswordHandler}
        />
      ) : null}
      {!otpSent && <ResetRequestForm onContinue={requestOtpHandler} />}
    </>
  );
}

function Loading() {
  return (
    <>
      <LoadingOverlay />
    </>
  );
}
